<template>
  <div class="editor">
    <div class="row">
      <div class="col">
        <editor-content class="editor__content bg-white p-2 border border-dark" :editor="editor"></editor-content>
      </div>
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Blockquote,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Placeholder
} from "tiptap-extensions";

import Image from "./nodes/Image";

export default {
  props: ["value", "filesUrl", "placeholder"],
  data() {
    return {
      editor: new Editor({
        onUpdate: ({ getHTML }) => {
          // this.$emit("update", getHTML());
          this.$emit("input", getHTML());
        },
        extensions: [
          new Placeholder({
            emptyEditorClass: "is-editor-empty",
            emptyNodeClass: "is-empty",
            emptyNodeText: this.placeholder,
            showOnlyWhenEditable: true,
            showOnlyCurrent: true
          }),
          new Blockquote(),
          new BulletList(),
          new ListItem(),
          new Bold(),
          new Italic(),
          new Image()
        ],
        content: this.value
      }),
      keepInBounds: true,
      showImageSelector: null,
      imageCommand: null
    };
  },
  methods: {
    insertImage(data) {
      if (data.url != null) {
        this.imageCommand({
          src: data.url,
          classes: "somenewone",
          alt: data.alt,
          title: data.title
        });
        this.showImageSelector = false;
      }
    },
    showImageSelectorModal(command) {
      this.imageCommand = command;
      this.showImageSelector = true;
    }
  },
  mounted() {},
  beforeDestroy() {
    this.editor.destroy();
  },
  components: {
    EditorContent,
    EditorMenuBar
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/bootstrap.scss";
</style>
<style lang="scss">
@import "../../../sass/styles.scss";
</style>
<style lang="scss">
.editor {
  margin: 0 auto 1.25rem auto;
}

.editor p.is-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.editor p.is-empty {
  // margin-bottom: 2rem;
}

.editor .ProseMirror {
  min-height: 5rem;
}
</style>